import {
  ActiveSubscriptionDataRouteType,
} from "routes/data-routes/billing-data/active-subscription/route.meta";
import scraperApi from "api";


export const loader: ActiveSubscriptionDataRouteType["route"]["loader"] = async ({ request }) => {
  return {
    activeSubscription: await scraperApi.subscription.active({ signal: request.signal })
  };
};
